import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppMobileMenuDropdown from './AppMobileMenuDropdown';
import i18n from 'i18next';
import { List, ListItemButton, ListItemText, Collapse } from "@mui/material";

const AppMobileMenuItems = (props) => {
    let { items, depthLevel, showMenu, setShowMenu } = props;
    const [dropdown, setDropdown] = useState(false);
    const [currentDepth, setCurrentDepth] = useState(depthLevel);

    useEffect(() => {
        setCurrentDepth((prev) => prev + 2);
    }, []);

    const toggleDropdown = (e) => {
        e.stopPropagation();
        setDropdown((prev) => !prev);
    };

    return (
        <>
            <ListItemButton onClick={toggleDropdown} sx={{ pl: currentDepth }}>
                <ListItemText primary={i18n.t(`AppHeader.${items.title}`)} />
                {items.submenu ? dropdown ? <span className="arrow-close" /> : <span className="arrow" /> : null}
            </ListItemButton>
            {items.submenu && (
                <Collapse in={dropdown} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {items.submenu.map((sub, index) => (
                            <React.Fragment key={sub.title + index}>
                                <ListItemButton
                                    component={Link}
                                    to={sub.path}
                                    sx={{ pl: (currentDepth + 2) }}
                                >
                                    <ListItemText primary={i18n.t(`AppHeader.${sub.title}`)} />
                                </ListItemButton>
                            </React.Fragment>
                        ))}
                    </List>
                </Collapse>
            )}
        </>
    );
};

export default AppMobileMenuItems;
